import React, { useState } from "react";
import Input from "@/components/elements/input/Input";
import JobsListItem from "@/pages/jobs/JobsListItem";
import { JobType } from "@/utils/types/JobType";
import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import api from "@/api/api";
import { useTranslation } from "react-i18next";

type Response = {
  data: JobType[];
  current_page: number;
  total_pages: number;
};

const ProfileDetailsJobs = ({ userId = "" }: { userId?: string }) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { t } = useTranslation();
  const jobs = useInfiniteQuery<Response>(
    ["jobs", searchQuery],
    async ({ pageParam = 0 }) => {
      const { data } = await api.get(
        `/api/v1/jobs?page=${pageParam}&q=${searchQuery}&user_id=${userId}`,
      );
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.current_page + 1;
        return nextPage <= lastPage.total_pages ? nextPage : false;
      },
    },
  );

  return (
    <>
      <Input
        placeholder={t("main.jobsTabs.placeholder")}
        name="jobs_keywords"
        onChange={(e) => setSearchQuery(e)}
        clearable
      />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {jobs.data &&
          jobs.data.pages.map(
            (page) =>
              page.data &&
              page.data.map((job: JobType) => (
                <JobsListItem key={job.id} job={job} showButtons={false} />
              )),
          )}
      </div>
    </>
  );
};

export default ProfileDetailsJobs;
